import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ spacing }) => ({
  cropContainer: {
    display: 'flex',
    minHeight: 300,
    width: '100%',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
}));
